import React from "react";
import { connect } from "react-redux";
import { setDashboardParams } from "../../../../store/actions";

class DashboardShiftSelector extends React.Component {
  handleShiftSelection = (ev) => {
    ev.preventDefault();
    this.props.setSelectedShift(+ev.target.value);
  };

  isSelected = (val) => {
    return this.props.selectedShift === val;
  };

  render() {
    return (
      <div>
        <div className="box-select-wrapper">
          <select
            className="box-selector"
            onChange={this.handleShiftSelection}
            disabled={this.props.isloading === true}
            value={this.props.selectedShift}
          >
            <option key="0" value={0}>
              All Shifts
            </option>
            {this.props.shifts.map((shift) => {
              return (
                <option key={shift.id} value={shift.id}>
                  {shift.name || `${shift.start_time} - ${shift.end_time}`}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shifts:
    state.aggregates.shifts && Array.isArray(state.aggregates.shifts.rows)
      ? state.aggregates.shifts.rows
      : [],
  selectedShift: state.dashboardParams.selectedShift,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedShift: (id) => dispatch(setDashboardParams({ selectedShift: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardShiftSelector);
